import { combineReducers } from 'redux';

import { authReducer } from '../features/auth';
import { meetingsReducer } from '../features/meetings';
import { scheduleMeetingsReducer } from '../features/scheduleMeeting';
import { usersReducer } from '../features/users';
import { membersReducer } from '../features/members';
import { appReducer } from '../features/app';
import { meetingRoomReducer } from '../features/meetingRoom';
import { settingsReducer } from '../features/settings';
import { meetingReportsReducer } from '../features/reports/meetingReport';
import { emailRouterReducer } from '../features/emailRouter';
import { groupsReducer } from '../features/group';
import { contactusReducer } from '../features/subPages';
import { livestreamingReducer } from '../features/livestreaming';
import { livestreamingRoomReducer } from '../features/livestreamingRoom';

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  settings: settingsReducer,
  meetings: meetingsReducer,
  scheduleMeeting: scheduleMeetingsReducer,
  meetingRoom: meetingRoomReducer,
  users: usersReducer,
  members: membersReducer,
  reports: meetingReportsReducer,
  emailRouter: emailRouterReducer,
  groups: groupsReducer,
  contactus: contactusReducer,
  livestreaming: livestreamingReducer,
  livestreamingRoom: livestreamingRoomReducer,
});

export default rootReducer;
